import { Getters } from 'vuex-smart-module';
import ProjectsState from './state';

export default class ProjectsGetters extends Getters<ProjectsState> {}
